import {
  GET_AVAILABLE_PRODUCTS,
  GET_ORDER_BUNDLE,
  GET_ORDER_BUNDLES,
  CAN_DO_RETURN_REQUEST,
  CREATE_RETURN_REQUEST
} from '@/utils/store/actionTypes'
import OrderBundle from '@/apollo/order_bundle/OrderBundle.graphql'
import OrderBundles from '@/apollo/order_bundle/OrderBundles.graphql'
import AvailableProducts from '@/apollo/product/GetAvailableProducts.graphql'
import { apolloClient } from '@/utils/store'
import { formatData } from '@/utils/apollo'

export default {
  /**
   * Get available products
   *
   * @param _
   * @param sizeId
   * @returns {Promise<*>}
   */
  async [GET_AVAILABLE_PRODUCTS] (_, { reference }) {
    const response = await apolloClient(this).query({
      query: AvailableProducts,
      variables: {
        productGroupSizeReference: reference
      },
      fetchPolicy: 'no-cache'
    })

    return formatData(response).data
  },

  /**
   * Gets an order bundle
   *
   * @param _
   * @param id
   * @returns {Promise<*>}
   */
  async [GET_ORDER_BUNDLE] (_, { id }) {
    const response = await apolloClient(this).query({
      query: OrderBundle,
      variables: {
        id: `/api/order_bundles/${id}`
      },
      fetchPolicy: 'no-cache'
    })

    return formatData(response).data
  },

  /**
   * Gets the order bundles
   *
   * @param _
   * @param limit
   * @param after
   * @returns {Promise<*>}
   */
  async [GET_ORDER_BUNDLES] (_, { limit, after }) {
    return await apolloClient(this).query({
      query: OrderBundles,
      variables: {
        limit,
        after
      },
      fetchPolicy: 'no-cache'
    })
  },
  async [CAN_DO_RETURN_REQUEST] (_, { orderId }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/orders/${orderId}/return-info`,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [CREATE_RETURN_REQUEST] (_, { orderId, productId, userIndicatedHasReceivedOrder, reason }) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/orders/${orderId}/return`,
      {
        productId,
        userIndicatedHasReceivedOrder,
        reason
      },
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  }
}
